<template>
  <div>
    <el-input :size="size" placeholder="请配置数据源" :value="text" readonly>
      <table class="property-field-table" cellspacing="0" cellpadding="0" slot="append">
        <tr>
          <td @click="clear">&times;</td>
          <td @click="toSelect">配置数据源</td>
        </tr>
      </table>
    </el-input>
    <data-source-select-dialog ref="dataSourceSelectDialog" @save="onSave" :dataType="dataType" :configColumn="configColumn" :configCondition="configCondition" :configOperation="configOperation" :endpoint="endpoint" :uiId="uiId"></data-source-select-dialog>
  </div>
</template>

<script>
import DataSourceSelectDialog from '../model/DataSourceSelectDialog'

export default {
  name: 'data-source-select-button',
  components: {
    DataSourceSelectDialog
  },
  props: {
    endpoint: { type: String, required: true },
    property: { type: Object, required: true },
    size: { type: String, required: false, default: 'mini' },
    dataType: { type: String, required: false },
    configColumn: { type: Boolean, required: false },
    configCondition: { type: Boolean, required: false },
    configOperation: { type: Boolean, required: false },
    uiId: { type: Number, required: true }
  },
  data () {
    return {
      text: ''
    }
  },
  watch: {
    'property.value': {
      handler: function (val) {
        this.text = !val ? '' : this.getText(JSON.parse(val))
      },
      immediate: true
    }
  },
  methods: {
    clear () {
      this.property.value = undefined
      this.text = ''
      this.$emit('change')
    },
    toSelect () {
      this.$refs.dataSourceSelectDialog.open(this.property.value)
    },
    onSave (dataSource) {
      this.property.value = JSON.stringify(dataSource)
      this.text = this.getText(dataSource)
      this.$emit('change')
    },
    getText (dataSource) {
      let type = dataSource.type
      if (type === 'model') {
        return `模型: ${dataSource.name}`
      }
      if (type === 'dynamicForm') {
        return `动态表单: ${dataSource.name}`
      }
      if (type === 'apiDataSource') {
        return `API数据源: ${dataSource.name}`
      }
      return dataSource.name
    }
  }
}
</script>
